export enum FlowlineShape {
  Orthogonal = 'Orthogonal'
}

export enum FlowlineType {
  Solid = 'Solid'
}

export enum FlowlineEnd {
  None = 'None',
  Classic = 'Classic',
  FullArrow = 'Block Thin',
  ZeroToOne = 'ERzeroToOne',
  ZeroToMany = 'ERzeroToMany'
}

export const FlowlineForm = {
  shape: FlowlineShape,
  type: FlowlineType,
  start: FlowlineEnd,
  end: FlowlineEnd
};

export type FlowlineForm = {
  shape: FlowlineShape;
  type: FlowlineType;
  start: FlowlineEnd;
  end: FlowlineEnd;
};
